/* RESPONSIBLE TEAM: team-knowledge-foundations */
import ApplicationAdapter from '../application';

export default class ArticleSyncSettingAdapter extends ApplicationAdapter {
  pathForType() {
    return 'article_sync_settings';
  }
}
